import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wage-calc-floating" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "calc-form" }
const _hoisted_5 = { class: "input-section" }
const _hoisted_6 = { class: "result-section" }
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = {
  key: 0,
  class: "total-amount"
}
const _hoisted_9 = { class: "result-item" }
const _hoisted_10 = { class: "result-row" }
const _hoisted_11 = { class: "result-value" }
const _hoisted_12 = { class: "wage-input-wrapper" }
const _hoisted_13 = { class: "wage-input-controls" }
const _hoisted_14 = { class: "result-item" }
const _hoisted_15 = { class: "result-row" }
const _hoisted_16 = { class: "result-value" }
const _hoisted_17 = { class: "result-item" }
const _hoisted_18 = { class: "result-row" }
const _hoisted_19 = { class: "result-value" }
const _hoisted_20 = { class: "wage-input-wrapper" }
const _hoisted_21 = { class: "wage-input-controls" }
const _hoisted_22 = { class: "result-item" }
const _hoisted_23 = { class: "result-row" }
const _hoisted_24 = { class: "result-value" }
const _hoisted_25 = { class: "wage-input-wrapper" }
const _hoisted_26 = { class: "wage-input-controls" }
const _hoisted_27 = { class: "result-section mt-3" }
const _hoisted_28 = { class: "section-title" }
const _hoisted_29 = {
  key: 0,
  class: "total-amount"
}
const _hoisted_30 = { class: "result-item" }
const _hoisted_31 = { class: "result-row" }
const _hoisted_32 = { class: "result-value" }
const _hoisted_33 = { class: "result-item" }
const _hoisted_34 = { class: "result-row" }
const _hoisted_35 = { class: "result-value" }
const _hoisted_36 = { class: "result-item" }
const _hoisted_37 = { class: "result-row" }
const _hoisted_38 = { class: "result-value" }
const _hoisted_39 = { class: "result-section mt-3" }
const _hoisted_40 = { class: "section-title" }
const _hoisted_41 = {
  key: 0,
  class: "total-amount"
}
const _hoisted_42 = { class: "result-item" }
const _hoisted_43 = { class: "result-row" }
const _hoisted_44 = { class: "result-value" }
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "result-item"
}
const _hoisted_47 = { class: "result-row" }
const _hoisted_48 = { class: "result-value" }
const _hoisted_49 = {
  key: 0,
  class: "result-section-right"
}
const _hoisted_50 = { class: "final-result-item" }
const _hoisted_51 = { class: "final-value" }
const _hoisted_52 = { class: "final-result-item deduction" }
const _hoisted_53 = { class: "final-value" }
const _hoisted_54 = {
  key: 0,
  class: "deduction-details"
}
const _hoisted_55 = { class: "deduction-detail-item" }
const _hoisted_56 = { class: "deduction-detail-label" }
const _hoisted_57 = { class: "deduction-detail-value" }
const _hoisted_58 = { class: "deduction-detail-item" }
const _hoisted_59 = { class: "deduction-detail-label" }
const _hoisted_60 = { class: "deduction-detail-value" }
const _hoisted_61 = { class: "deduction-detail-item" }
const _hoisted_62 = { class: "deduction-detail-label" }
const _hoisted_63 = { class: "deduction-detail-value" }
const _hoisted_64 = { class: "deduction-detail-item" }
const _hoisted_65 = { class: "deduction-detail-label" }
const _hoisted_66 = { class: "deduction-detail-value" }
const _hoisted_67 = { class: "deduction-detail-item" }
const _hoisted_68 = { class: "deduction-detail-label" }
const _hoisted_69 = { class: "deduction-detail-value" }
const _hoisted_70 = { class: "deduction-detail-item" }
const _hoisted_71 = { class: "deduction-detail-label" }
const _hoisted_72 = { class: "deduction-detail-value" }
const _hoisted_73 = { class: "deduction-detail-item" }
const _hoisted_74 = { class: "deduction-detail-label" }
const _hoisted_75 = { class: "deduction-detail-value" }
const _hoisted_76 = { class: "final-result-item highlight" }
const _hoisted_77 = { class: "final-value" }
const _hoisted_78 = { class: "final-result-item" }
const _hoisted_79 = { class: "final-value" }
const _hoisted_80 = { class: "final-result-item" }
const _hoisted_81 = {
  class: "final-value",
  style: {"color":"#dc2626"}
}
const _hoisted_82 = { class: "final-result-item deduction" }
const _hoisted_83 = { class: "final-value" }
const _hoisted_84 = {
  key: 0,
  class: "deduction-details"
}
const _hoisted_85 = { class: "deduction-detail-item" }
const _hoisted_86 = { class: "deduction-detail-label" }
const _hoisted_87 = { class: "deduction-detail-value" }
const _hoisted_88 = { class: "deduction-detail-item" }
const _hoisted_89 = { class: "deduction-detail-label" }
const _hoisted_90 = { class: "deduction-detail-value" }
const _hoisted_91 = { class: "deduction-detail-item" }
const _hoisted_92 = { class: "deduction-detail-label" }
const _hoisted_93 = { class: "deduction-detail-value" }
const _hoisted_94 = { class: "deduction-detail-item" }
const _hoisted_95 = { class: "deduction-detail-label" }
const _hoisted_96 = { class: "deduction-detail-value" }
const _hoisted_97 = { class: "deduction-detail-item" }
const _hoisted_98 = { class: "deduction-detail-label" }
const _hoisted_99 = { class: "deduction-detail-value" }
const _hoisted_100 = { class: "deduction-detail-item" }
const _hoisted_101 = { class: "deduction-detail-label" }
const _hoisted_102 = { class: "deduction-detail-value" }
const _hoisted_103 = { class: "deduction-detail-item" }
const _hoisted_104 = { class: "deduction-detail-label" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { style: {"white-space":"pre-line"} }
const _hoisted_107 = { class: "deduction-detail-value" }
const _hoisted_108 = { class: "final-result-item highlight profit" }
const _hoisted_109 = { class: "final-value" }
const _hoisted_110 = {
  key: 1,
  class: "payroll-calculation-section"
}
const _hoisted_111 = { class: "result-item" }
const _hoisted_112 = { class: "result-row" }
const _hoisted_113 = { class: "result-value" }
const _hoisted_114 = { class: "result-row" }
const _hoisted_115 = { class: "result-value" }
const _hoisted_116 = { class: "result-row" }
const _hoisted_117 = { class: "result-value" }
const _hoisted_118 = { class: "result-row total-row" }
const _hoisted_119 = { class: "result-value" }
const _hoisted_120 = { class: "result-item" }
const _hoisted_121 = { class: "result-row" }
const _hoisted_122 = { class: "result-label" }
const _hoisted_123 = { class: "result-value" }
const _hoisted_124 = { class: "result-row" }
const _hoisted_125 = { class: "result-label" }
const _hoisted_126 = { class: "result-value" }
const _hoisted_127 = { class: "result-row" }
const _hoisted_128 = { class: "result-label" }
const _hoisted_129 = { class: "result-value" }
const _hoisted_130 = { class: "result-row" }
const _hoisted_131 = { class: "result-label" }
const _hoisted_132 = { class: "result-value" }
const _hoisted_133 = { class: "result-row" }
const _hoisted_134 = { class: "result-label" }
const _hoisted_135 = { class: "result-value" }
const _hoisted_136 = { class: "result-row" }
const _hoisted_137 = { class: "result-label" }
const _hoisted_138 = { class: "result-value" }
const _hoisted_139 = { class: "result-row" }
const _hoisted_140 = { class: "result-label" }
const _hoisted_141 = { class: "result-value" }
const _hoisted_142 = { class: "result-row total-row deduction-row" }
const _hoisted_143 = { class: "result-value" }
const _hoisted_144 = { class: "result-item" }
const _hoisted_145 = { class: "result-row" }
const _hoisted_146 = { class: "result-label" }
const _hoisted_147 = { class: "result-value" }
const _hoisted_148 = { class: "result-row" }
const _hoisted_149 = { class: "result-label" }
const _hoisted_150 = { class: "result-value" }
const _hoisted_151 = { class: "result-row" }
const _hoisted_152 = { class: "result-label" }
const _hoisted_153 = { class: "result-value" }
const _hoisted_154 = { class: "result-row" }
const _hoisted_155 = { class: "result-label" }
const _hoisted_156 = { class: "result-value" }
const _hoisted_157 = { class: "result-row" }
const _hoisted_158 = { class: "result-label" }
const _hoisted_159 = { class: "result-value" }
const _hoisted_160 = { class: "result-row" }
const _hoisted_161 = { class: "result-label" }
const _hoisted_162 = { class: "result-value" }
const _hoisted_163 = { class: "result-row" }
const _hoisted_164 = { class: "result-label" }
const _hoisted_165 = ["disabled"]
const _hoisted_166 = { style: {"white-space":"pre-line"} }
const _hoisted_167 = { class: "result-value" }
const _hoisted_168 = { class: "result-row total-row deduction-row" }
const _hoisted_169 = { class: "result-value" }

import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import axios from 'axios';

// 상태 관리

export default /*@__PURE__*/_defineComponent({
  __name: 'WageCalc',
  setup(__props) {

const isExpanded = ref(false);
const currentYear = new Date().getFullYear();
const selectedYear = ref(currentYear);

// 패널 크기 조절
const panelHeight = ref(600); // 기본 높이
const isResizing = ref(false);
const resizeStartY = ref(0);
const resizeStartHeight = ref(0);

// 연도 옵션 (현재 연도 ±1년)
const yearOptions = ref([
  currentYear - 1,
  currentYear,
  currentYear + 1
]);

// 원단위 절삭 함수 (예: 51131 -> 51130)
const truncateToTen = (value: number) => Math.floor(value / 10) * 10;

// 세금 데이터
const taxData = ref({}) as any;
const sojiData = ref({}) as any;

// 공휴일 데이터
const holidaysData = ref<any[]>([]);

// 수가 데이터
const sugaList = ref<any[]>([]);
const selectedSugaTime = ref<string>('');

// 선택된 수가 정보
const selectedSuga = computed(() => {
  if (!selectedSugaTime.value) return null;
  return sugaList.value.find((suga: any) => suga.suga_rank === selectedSugaTime.value);
});

// 급여 계산 데이터
const hourlyWage = ref(''); // 사용자가 입력하는 시급 (표시용, 포맷된 문자열)
const calculatedHourlyWage = ref(0); // 계산된 시급 (계산용, 숫자)
const weeklyHolidayAllowance = ref(''); // 자동 계산된 주휴수당 (시급의 20%)
const annualLeaveAllowance = ref(''); // 사용자가 입력하는 연차수당 (표시용, 포맷된 문자열)
const calculatedAnnualLeaveAllowance = ref(0); // 계산된 연차수당 (계산용, 숫자)
// 사용자 입력 근무일수
const workingDaysInput = ref<string>('');

// 상세보기 상태
const showDetail = ref({
  employeeDeductions: false, // 근로자 공제 접기/펼치기
  centerDeductions: false // 기관 공제 접기/펼치기
});

// 근로자 공제 체크박스 상태
const applyEmployeeDeductions = ref({
  nationalPension: true,
  healthInsurance: true,
  longTermCare: true,
  employmentInsurance: true,
  incomeTax: true,
  localTax: true,
  supportDeduction: true
});

// 기관 공제 체크박스 상태
const applyCenterDeductions = ref({
  nationalPension: true,
  healthInsurance: true,
  longTermCare: true,
  employmentInsurance: true,
  unemployment: true,
  industrialAccident: true,
  retirement: true
});

// 연차수당 계산을 위한 데이터
const vacationDays = ref('11');
const dailyWorkHours = ref('8');
const vacationYear = ref(2); // 연차차수 (1년차, 2년차 등)

// 근로기준법에 따른 연차차수 옵션
const vacationYearOptions = ref([
  { value: 1, label: '1년차', days: 11 },
  { value: 2, label: '2년차', days: 15 },
  { value: 3, label: '3년차', days: 15 },
  { value: 4, label: '4년차', days: 16 },
  { value: 5, label: '5년차', days: 16 },
  { value: 6, label: '6년차', days: 17 },
  { value: 7, label: '7년차', days: 17 },
  { value: 8, label: '8년차', days: 18 },
  { value: 9, label: '9년차', days: 18 },
  { value: 10, label: '10년차', days: 19 },
  { value: 10, label: '11년차', days: 19 },
  { value: 10, label: '12년차', days: 20 },
  { value: 10, label: '13년차', days: 20 },
  { value: 10, label: '14년차', days: 21 },
  { value: 10, label: '15년차', days: 21 },
  { value: 10, label: '16년차', days: 22 },
  { value: 10, label: '17년차', days: 22 },
  { value: 10, label: '18년차', days: 23 },
  { value: 10, label: '19년차', days: 23 },
  { value: 10, label: '20년차', days: 24 },
  { value: 10, label: '21년차이상', days: 25 },
]);

// 더 이상 사용되지 않는 연차차수 관련 함수 제거

// 스낵바
const snackbar = ref({
  show: false,
  message: "",
  color: "error"
});

// 스낵바 표시 함수
const showSnackbar = (message: string, color: string = "error") => {
  snackbar.value = {
    show: true,
    message,
    color
  };
};

// 세금 데이터 가져오기 함수
const getTax = async () => {
  try {
    const year = selectedYear.value.toString();
    const response = await axios.get(`/api/calc/tax/${year}`);
    if (response.data.success) {
      taxData.value = response.data.data.taxRate;
      sojiData.value = response.data.data.soji || [];
      if(!taxData.value){
        selectedYear.value = currentYear;
        showSnackbar("해당 연도로 변경할 수 없습니다");
        getTax();
      } else {
        // 최저시급 기반으로 초기값 설정
        const minWage = taxData.value.tr_time_pay || 0;
        if (minWage > 0) {
          // 시급 초기값을 최저시급으로 설정
          hourlyWage.value = new Intl.NumberFormat('ko-KR').format(minWage);
          calculatedHourlyWage.value = minWage;
          // 주휴수당 자동 계산
          calculateWeeklyHolidayAllowance();
          // 연차수당 초기값을 시급 기반으로 계산
          // 계산 공식: 시급 × (15/12) ÷ 근무일수(20일 기본값)
          const defaultWorkingDays = 20;
          const calculatedAnnualLeave = Math.round(minWage * (15 / 12) / defaultWorkingDays);
          annualLeaveAllowance.value = new Intl.NumberFormat('ko-KR').format(calculatedAnnualLeave);
          calculatedAnnualLeaveAllowance.value = calculatedAnnualLeave;
        }
      }
    }
  } catch (error: any) {
    console.error("세액 조회 오류:", error);
  }
};

// 시급과 연차수당 기반으로 주휴수당 자동 계산
const calculateWeeklyHolidayAllowance = () => {
  const numericHourlyWage = parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) || 0;
  if (numericHourlyWage > 0) {
    const calculatedWeeklyHoliday = Math.round(numericHourlyWage * 0.2);
    weeklyHolidayAllowance.value = new Intl.NumberFormat('ko-KR').format(calculatedWeeklyHoliday);
  } else {
    weeklyHolidayAllowance.value = '';
  }
};

// 연도 변경 핸들러
const onYearChange = async () => {
  calculatedHourlyWage.value = 0; // 계산된 시급 초기화
  calculatedAnnualLeaveAllowance.value = 0; // 계산된 연차수당 초기화
  await getTax();
  await loadHolidays();
  await loadSuga();
  // loadSuga에서 자동으로 '180분'을 기본값으로 설정함
};

// 공휴일 데이터 가져오기
const loadHolidays = async () => {
  try {
    const year = selectedYear.value.toString();
    const response = await axios.get(`/api/calc/holidays/${year}`);
    if (response.data.success) {
      holidaysData.value = response.data.data || [];
    }
  } catch (error: any) {
    console.error("공휴일 조회 오류:", error);
  }
};

// 수가 데이터 가져오기
const loadSuga = async () => {
  try {
    const year = selectedYear.value.toString();
    const response = await axios.get(`/api/calc/suga/${year}`);
    if (response.data.success) {
      sugaList.value = response.data.data || [];
      // '180분' 항목을 기본값으로 설정
      const defaultSuga = sugaList.value.find((suga: any) => suga.suga_rank === '180분');
      if (defaultSuga) {
        selectedSugaTime.value = defaultSuga.suga_rank;
      }
    }
  } catch (error: any) {
    console.error("수가 조회 오류:", error);
  }
};

// 최종 근무일수 (사용자 입력, 기본값 20일)
const workingDaysFinal = computed(() => {
  const inputStr = String(workingDaysInput.value || '').trim();
  // 입력이 완전히 비어있으면 디폴트 20일
  if (inputStr === '') {
    return 20;
  }
  // 숫자 파싱 (0 포함)
  const v = parseInt(inputStr.replace(/[^\d]/g, ''));
  // 0 이상의 유효한 숫자면 그 값 사용, 아니면 디폴트 20일
  return Number.isFinite(v) && v >= 0 ? v : 20;
});

// 수가 시간을 시간 단위로 변환하는 함수 (예: "180분" -> 3시간)
const parseSugaTimeToHours = (sugaRank: string): number => {
  if (!sugaRank) return 0;
  
  // "180분", "240분" 같은 형식에서 숫자만 추출
  const minutes = parseFloat(String(sugaRank).replace(/[^\d.-]/g, '')) || 0;
  
  // 분을 시간으로 변환
  return minutes / 60;
};

// 퇴직금 적용 가능 여부 계산 (근무일수 * 수가시간 >= 60시간)
const canApplyRetirement = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_rank) {
    return false;
  }
  
  const sugaHours = parseSugaTimeToHours(selectedSuga.value.suga_rank);
  const totalHours = workingDaysFinal.value * sugaHours;
  
  return totalHours >= 60;
});

// 퇴직금 체크박스 비활성화 메시지
const retirementTooltipMessage = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_rank) {
    return '수가 시간을 선택해주세요';
  }
  
  const sugaHours = parseSugaTimeToHours(selectedSuga.value.suga_rank);
  const totalHours = workingDaysFinal.value * sugaHours;
  
  if (totalHours < 60) {
    return `월 수가시간이 60시간 미만입니다.\n(현재: ${totalHours.toFixed(1)}시간, 필요: 60시간 이상)`;
  }
  
  return '';
});

// 시급 입력 필드 포커스 이벤트 (컴마 제거)
const onHourlyWageFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  // 컴마 제거하여 숫자만 표시
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  hourlyWage.value = numericValue;
};

// 시급 입력 필드 포커스 아웃 이벤트 (검증 및 컴마 추가)
const onHourlyWageBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  // 숫자만 추출
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const numeric = parseInt(numericValue);
    const minWage = taxData.value?.tr_time_pay || 0;
    
    // 최저시급 이하인 경우 경고 후 최저시급으로 복원
    if (minWage > 0 && numeric < minWage) {
      showSnackbar(`시급은 최소 ${new Intl.NumberFormat('ko-KR').format(minWage)}원 이상이어야 합니다.`, 'error');
      const formattedValue = new Intl.NumberFormat('ko-KR').format(minWage);
      input.value = formattedValue;
      hourlyWage.value = formattedValue;
      calculatedHourlyWage.value = minWage;
      calculateWeeklyHolidayAllowance();
      return;
    }
    
    // 천원단위로 컴마 추가
    const formattedValue = new Intl.NumberFormat('ko-KR').format(numeric);
    input.value = formattedValue;
    hourlyWage.value = formattedValue;
    calculatedHourlyWage.value = numeric;
    
    // 주휴수당 자동 계산
    calculateWeeklyHolidayAllowance();
  } else {
    // 빈 값이면 최저시급으로 설정
    const minWage = taxData.value?.tr_time_pay || 0;
    if (minWage > 0) {
      const formattedValue = new Intl.NumberFormat('ko-KR').format(minWage);
      input.value = formattedValue;
      hourlyWage.value = formattedValue;
      calculatedHourlyWage.value = minWage;
      calculateWeeklyHolidayAllowance();
    }
  }
};

// 시급 입력 필드 입력 이벤트 (숫자만 허용)
const onHourlyWageInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // 숫자가 아닌 문자 제거
  value = value.replace(/[^\d]/g, '');
  
  // 최대 9자리까지 제한
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  hourlyWage.value = value;
};

// 연차수당 입력 필드 포커스 이벤트 (컴마 제거)
const onAnnualLeaveAllowanceFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  // 컴마 제거하여 숫자만 표시
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  annualLeaveAllowance.value = numericValue;
};

// 연차수당 입력 필드 포커스 아웃 이벤트 (검증 및 컴마 추가)
const onAnnualLeaveAllowanceBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  // 숫자만 추출
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const numeric = parseInt(numericValue);
    
    // 천원단위로 컴마 추가
    const formattedValue = new Intl.NumberFormat('ko-KR').format(numeric);
    input.value = formattedValue;
    annualLeaveAllowance.value = formattedValue;
    calculatedAnnualLeaveAllowance.value = numeric;
  } else {
    // 빈 값이면 0으로 설정
    input.value = '0';
    annualLeaveAllowance.value = '0';
    calculatedAnnualLeaveAllowance.value = 0;
  }
};

// 연차수당 입력 필드 입력 이벤트 (숫자만 허용)
const onAnnualLeaveAllowanceInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // 숫자가 아닌 문자 제거
  value = value.replace(/[^\d]/g, '');
  
  // 최대 9자리까지 제한
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  annualLeaveAllowance.value = value;
};

// 시급 기반 연차수당 계산 함수
const calculateAnnualLeaveByHourlyWage = () => {
  const numericHourlyWage = parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) || 0;
  
  if (numericHourlyWage <= 0) {
    showSnackbar('시급을 먼저 입력해주세요.', 'error');
    return;
  }
  
  if (workingDaysFinal.value <= 0) {
    showSnackbar('근무일수를 먼저 입력해주세요.', 'error');
    return;
  }
  
  // 연차수당 계산: 시급 * (15/12) / 근로일수
  const calculatedValue = Math.round(numericHourlyWage * (15 / 12) / workingDaysFinal.value);
  
  // 포맷팅하여 입력 필드에 설정
  const formattedValue = new Intl.NumberFormat('ko-KR').format(calculatedValue);
  annualLeaveAllowance.value = formattedValue;
  calculatedAnnualLeaveAllowance.value = calculatedValue;
  
  showSnackbar('연차수당이 계산되었습니다.', 'success');
};

// 시급 입력 필드 엔터 키 이벤트 (포커스 아웃)
const onHourlyWageEnter = (event: KeyboardEvent) => {
  const input = event.target as HTMLInputElement;
  input.blur();
};

// 연차수당 입력 필드 엔터 키 이벤트 (포커스 아웃)
const onAnnualLeaveAllowanceEnter = (event: KeyboardEvent) => {
  const input = event.target as HTMLInputElement;
  input.blur();
};

// 근무일수 입력 필드 엔터 키 이벤트 (포커스 아웃)
const onWorkingDaysEnter = (event: KeyboardEvent) => {
  const input = event.target as HTMLInputElement;
  input.blur();
};

// 시급 1원 증가
const incrementHourlyWage = () => {
  const numeric = parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) || 0;
  const newValue = numeric + 1;
  hourlyWage.value = new Intl.NumberFormat('ko-KR').format(newValue);
  calculatedHourlyWage.value = newValue;
  calculateWeeklyHolidayAllowance();
};

// 시급 1원 감소
const decrementHourlyWage = () => {
  const numeric = parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) || 0;
  const minWage = taxData.value?.tr_time_pay || 0;
  if (numeric > minWage) {
    const newValue = numeric - 1;
    hourlyWage.value = new Intl.NumberFormat('ko-KR').format(newValue);
    calculatedHourlyWage.value = newValue;
    calculateWeeklyHolidayAllowance();
  } else {
    showSnackbar(`시급은 최소 ${new Intl.NumberFormat('ko-KR').format(minWage)}원 이상이어야 합니다.`, 'error');
  }
};

// 연차수당 1원 증가
const incrementAnnualLeaveAllowance = () => {
  const numeric = parseFloat(String(annualLeaveAllowance.value).replace(/[^\d]/g, '')) || 0;
  const newValue = numeric + 1;
  annualLeaveAllowance.value = new Intl.NumberFormat('ko-KR').format(newValue);
  calculatedAnnualLeaveAllowance.value = newValue;
};

// 연차수당 1원 감소
const decrementAnnualLeaveAllowance = () => {
  const numeric = parseFloat(String(annualLeaveAllowance.value).replace(/[^\d]/g, '')) || 0;
  if (numeric > 0) {
    const newValue = numeric - 1;
    annualLeaveAllowance.value = new Intl.NumberFormat('ko-KR').format(newValue);
    calculatedAnnualLeaveAllowance.value = newValue;
  }
};

// 근무일수 1일 증가
const incrementWorkingDays = () => {
  const numeric = parseInt(String(workingDaysInput.value).replace(/[^\d]/g, '')) || 0;
  const newValue = numeric + 1;
  workingDaysInput.value = String(newValue);
};

// 근무일수 1일 감소
const decrementWorkingDays = () => {
  const numeric = parseInt(String(workingDaysInput.value).replace(/[^\d]/g, '')) || 0;
  if (numeric > 0) {
    const newValue = numeric - 1;
    workingDaysInput.value = String(newValue);
  }
};

// 연속 실행 관련 변수
let continuousTimer: ReturnType<typeof setTimeout> | null = null;
let continuousInterval: ReturnType<typeof setInterval> | null = null;
let continuousType: 'hourlyWage' | 'annualLeave' | 'workingDays' | null = null;
let continuousDirection: 'increment' | 'decrement' | null = null;
let mousedownTime: number = 0;
let hasExecutedOnce: boolean = false;

// 연속 증가 시작
const startContinuousIncrement = (type: 'hourlyWage' | 'annualLeave' | 'workingDays') => {
  // 기존 타이머/인터벌 정리
  stopContinuousIncrement();
  
  mousedownTime = Date.now();
  hasExecutedOnce = false;
  continuousType = type;
  continuousDirection = 'increment';
  
  // 0.4초 후 연속 실행 시작
  continuousTimer = setTimeout(() => {
    if (continuousType && continuousDirection === 'increment') {
      // 첫 실행
      if (!hasExecutedOnce) {
        if (continuousType === 'hourlyWage') {
          incrementHourlyWage();
        } else if (continuousType === 'annualLeave') {
          incrementAnnualLeaveAllowance();
        } else if (continuousType === 'workingDays') {
          incrementWorkingDays();
        }
        hasExecutedOnce = true;
      }
      
      // 100ms마다 실행 (적당한 속도)
      continuousInterval = setInterval(() => {
        if (continuousType === 'hourlyWage') {
          incrementHourlyWage();
        } else if (continuousType === 'annualLeave') {
          incrementAnnualLeaveAllowance();
        } else if (continuousType === 'workingDays') {
          incrementWorkingDays();
        }
      }, 100);
    }
  }, 400);
};

// 연속 감소 시작
const startContinuousDecrement = (type: 'hourlyWage' | 'annualLeave' | 'workingDays') => {
  // 기존 타이머/인터벌 정리
  stopContinuousIncrement();
  
  mousedownTime = Date.now();
  hasExecutedOnce = false;
  continuousType = type;
  continuousDirection = 'decrement';
  
  // 0.4초 후 연속 실행 시작
  continuousTimer = setTimeout(() => {
    if (continuousType && continuousDirection === 'decrement') {
      // 첫 실행
      if (!hasExecutedOnce) {
        if (continuousType === 'hourlyWage') {
          decrementHourlyWage();
        } else if (continuousType === 'annualLeave') {
          decrementAnnualLeaveAllowance();
        } else if (continuousType === 'workingDays') {
          decrementWorkingDays();
        }
        hasExecutedOnce = true;
      }
      
      // 100ms마다 실행 (적당한 속도)
      continuousInterval = setInterval(() => {
        if (continuousType === 'hourlyWage') {
          decrementHourlyWage();
        } else if (continuousType === 'annualLeave') {
          decrementAnnualLeaveAllowance();
        } else if (continuousType === 'workingDays') {
          decrementWorkingDays();
        }
      }, 100);
    }
  }, 400);
};

// 연속 실행 정지
const stopContinuousIncrement = () => {
  const mouseupTime = Date.now();
  const elapsed = mouseupTime - mousedownTime;
  
  // 0.4초 이내에 mouseup이 발생하면 한 번만 실행 (클릭)
  if (elapsed < 400 && !hasExecutedOnce && continuousType && continuousDirection) {
    if (continuousDirection === 'increment') {
      if (continuousType === 'hourlyWage') {
        incrementHourlyWage();
      } else if (continuousType === 'annualLeave') {
        incrementAnnualLeaveAllowance();
      } else if (continuousType === 'workingDays') {
        incrementWorkingDays();
      }
    } else if (continuousDirection === 'decrement') {
      if (continuousType === 'hourlyWage') {
        decrementHourlyWage();
      } else if (continuousType === 'annualLeave') {
        decrementAnnualLeaveAllowance();
      } else if (continuousType === 'workingDays') {
        decrementWorkingDays();
      }
    }
  }
  
  if (continuousTimer) {
    clearTimeout(continuousTimer);
    continuousTimer = null;
  }
  if (continuousInterval) {
    clearInterval(continuousInterval);
    continuousInterval = null;
  }
  continuousType = null;
  continuousDirection = null;
  hasExecutedOnce = false;
};

// 상세보기 토글 함수
const toggleDetail = (type: string) => {
  showDetail.value[type as keyof typeof showDetail.value] = !showDetail.value[type as keyof typeof showDetail.value];
};

// 기존 직접입력 및 연차수당 계산 함수 제거 (더 이상 필요 없음)

// 근무일수 입력 이벤트
const onWorkingDaysInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // 숫자만 허용
  value = value.replace(/[^\d]/g, '');
  
  // 최대 3자리까지 제한
  if (value.length > 3) {
    value = value.slice(0, 3);
  }
  
  input.value = value;
  workingDaysInput.value = value;
  // workingDaysFinal이 computed로 자동 업데이트되고, 연관된 모든 값들이 자동 계산됨
};

// 합산금액 계산 (시급 + 주휴수당 + 연차수당)
const totalHourlyWage = computed(() => {
  const numericHourlyWage = parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) || 0;
  const numericWeeklyHoliday = parseFloat(String(weeklyHolidayAllowance.value).replace(/[^\d]/g, '')) || 0;
  const numericAnnualLeave = parseFloat(String(annualLeaveAllowance.value).replace(/[^\d]/g, '')) || 0;
  
  const total = numericHourlyWage + numericWeeklyHoliday + numericAnnualLeave;
  
  if (total > 0) {
    return new Intl.NumberFormat('ko-KR').format(Math.round(total)) + '원';
  }
  return '';
});

// 수가 시간 선택 변경 이벤트
const onSugaTimeChange = () => {
  // 수가 선택 시 필요한 추가 처리가 있으면 여기에 구현
};

// 월 총 임금 계산 (수가 금액 × 근무일수)
const monthlyTotalWage = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_money) return '';
  const sugaMoney = Number(selectedSuga.value.suga_money);
  if (sugaMoney > 0 && workingDaysFinal.value > 0) {
    return new Intl.NumberFormat('ko-KR').format(Math.round(sugaMoney * workingDaysFinal.value)) + '원';
  }
  return '';
});

// 수가총액 계산 (수가 금액 × 근무일수) - 포맷된 문자열
const sugaTotalAmount = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_money) return '';
  const sugaMoney = Number(selectedSuga.value.suga_money);
  if (sugaMoney > 0 && workingDaysFinal.value > 0) {
    return formatMoney(Math.round(sugaMoney * workingDaysFinal.value)) + '원';
  }
  return '';
});

// 수가총액 계산 (수가 금액 × 근무일수) - 숫자 버전 (계산용)
const sugaTotalAmountNumeric = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_money) return 0;
  const sugaMoney = Number(selectedSuga.value.suga_money);
  if (sugaMoney > 0 && workingDaysFinal.value > 0) {
    return Math.round(sugaMoney * workingDaysFinal.value);
  }
  return 0;
});

// 순수익 계산 (월 수가 - 월 급여 - 기관 공제)
const netProfit = computed(() => {
  return Math.max(0, sugaTotalAmountNumeric.value - basicTotalPay.value - totalCenterDeductions.value);
});

// 월 평균 임금 계산 (월 총 임금 / 근무일수)

// 월 수가시간 계산 (수가시간 × 근무일수)
const totalSugaHours = computed(() => {
  if (!selectedSuga.value || !selectedSuga.value.suga_rank) return 0;
  const sugaHours = parseSugaTimeToHours(selectedSuga.value.suga_rank);
  return sugaHours * workingDaysFinal.value;
});

// 실제 사용할 시급 계산 (계산된 시급 사용, 없으면 최저시급)
const actualTimePay = computed(() => {
  return calculatedHourlyWage.value > 0 ? calculatedHourlyWage.value : (taxData.value?.tr_time_pay || 0);
});

// 시급 입력값 변경 감지하여 주휴수당 자동 재계산
watch(() => hourlyWage.value, () => {
  // 입력 중에는 재계산하지 않음 (blur 시에만 재계산)
}, { deep: true });

// 기본급 계산 (PgmPayroll.vue 방식: 시급 * suga_hours)
const basicPay = computed(() => {
  if (actualTimePay.value === 0 || totalSugaHours.value === 0) return 0;
  return Math.round(actualTimePay.value * totalSugaHours.value);
});

// 주휴수당 계산 (PgmPayroll.vue 방식: 시급 * suga_hours * 0.2)
const weeklyHolidayPay = computed(() => {
  if (actualTimePay.value === 0 || totalSugaHours.value === 0) return 0;
  return Math.round(actualTimePay.value * totalSugaHours.value * 0.2);
});

// 연차수당 계산 (시간당 연차수당 * 월 수가시간)
const annualLeavePay = computed(() => {
  if (totalSugaHours.value === 0) return 0;
  
  // 시간당 연차수당 가져오기 (사용자가 입력한 값)
  const numericAnnualLeave = calculatedAnnualLeaveAllowance.value || 0;
  
  if (numericAnnualLeave > 0) {
    // 시간당 연차수당 * 월 수가시간 = 월간 연차수당
    return Math.round(numericAnnualLeave * totalSugaHours.value);
  }
  
  return 0;
});

// 기본급여 합계 (기본급 + 주휴수당 + 연차수당)
const basicTotalPay = computed(() => {
  return basicPay.value + weeklyHolidayPay.value + annualLeavePay.value;
});

// 과세 급여 (기본급여 합계)
const taxablePay = computed(() => {
  return basicTotalPay.value;
});

// 소득세 계산 함수
const calculateIncomeTax = (taxableIncome: number) => {
  if (!sojiData.value || sojiData.value.length === 0) {
    return 0;
  }
  
  for (let i = 0; i < sojiData.value.length; i++) {
    const obj = sojiData.value[i];
    const minIncome = obj.income1 * 1000;
    const maxIncome = obj.income2 * 1000;
    
    if (taxableIncome >= minIncome && taxableIncome < maxIncome) {
      return Math.round(obj.depe_1);
    }
  }
  
  return 0;
};

// 근로자 공제 계산
const employeeDeductions = computed(() => {
  if (!taxData.value || !taxData.value.tr_time_pay) {
    return {
      nationalPension: 0,
      healthInsurance: 0,
      employmentInsurance: 0,
      longTermCare: 0,
      supportDeduction: 0
    };
  }
  
  const calculatedNationalPension = truncateToTen(taxablePay.value * taxData.value.tr_yeon);
  const calculatedHealthInsurance = truncateToTen(taxablePay.value * taxData.value.tr_gun);
  const calculatedEmploymentInsurance = truncateToTen(taxablePay.value * taxData.value.tr_go);
  const calculatedLongTermCare = truncateToTen(calculatedHealthInsurance * taxData.value.tr_jang);
  
  // 지원공제는 장기근속수당이 있는 경우에만 계산 (현재는 0으로 설정)
  const calculatedSupportDeduction = 0;
  
  return {
    nationalPension: applyEmployeeDeductions.value.nationalPension ? calculatedNationalPension : 0,
    healthInsurance: applyEmployeeDeductions.value.healthInsurance ? calculatedHealthInsurance : 0,
    employmentInsurance: applyEmployeeDeductions.value.employmentInsurance ? calculatedEmploymentInsurance : 0,
    longTermCare: applyEmployeeDeductions.value.longTermCare ? calculatedLongTermCare : 0,
    supportDeduction: applyEmployeeDeductions.value.supportDeduction ? calculatedSupportDeduction : 0
  };
});

// 기관 공제 계산 (사업자 부담분)
const centerDeductions = computed(() => {
  if (!taxData.value || !taxData.value.tr_time_pay) {
    return {
      nationalPension: 0,
      healthInsurance: 0,
      employmentInsurance: 0,
      longTermCare: 0,
      unemployment: 0,
      industrialAccident: 0,
      retirement: 0
    };
  }
  
  // 사업자 부담분은 근로자와 동일한 비율로 계산 (일반적으로 50:50이지만, 일부는 다를 수 있음)
  // 여기서는 근로자와 동일한 비율로 계산하되, 실제로는 사업자 부담 비율이 다를 수 있음
  const calculatedNationalPension = truncateToTen(taxablePay.value * taxData.value.tr_yeon);
  const calculatedHealthInsurance = truncateToTen(taxablePay.value * taxData.value.tr_gun);
  const calculatedEmploymentInsurance = truncateToTen(taxablePay.value * taxData.value.tr_go);
  const calculatedLongTermCare = truncateToTen(calculatedHealthInsurance * taxData.value.tr_jang);
  const calculatedUnemployment = truncateToTen(taxablePay.value * taxData.value.tr_sil);
  const calculatedIndustrialAccident = truncateToTen(taxablePay.value * taxData.value.tr_san);
  
  // 퇴직금 = 세전 총 월급여(기본급 + 주휴수당 + 연차수당) / 12 (체크박스가 체크되어 있을 때만)
  let calculatedRetirement = 0;
  if (applyCenterDeductions.value.retirement) {
    calculatedRetirement = truncateToTen(basicTotalPay.value / 12);
  }
  
  return {
    nationalPension: applyCenterDeductions.value.nationalPension ? calculatedNationalPension : 0,
    healthInsurance: applyCenterDeductions.value.healthInsurance ? calculatedHealthInsurance : 0,
    employmentInsurance: applyCenterDeductions.value.employmentInsurance ? calculatedEmploymentInsurance : 0,
    longTermCare: applyCenterDeductions.value.longTermCare ? calculatedLongTermCare : 0,
    unemployment: applyCenterDeductions.value.unemployment ? calculatedUnemployment : 0,
    industrialAccident: applyCenterDeductions.value.industrialAccident ? calculatedIndustrialAccident : 0,
    retirement: calculatedRetirement
  };
});

// 세금 계산
const tax = computed(() => {
  const calculatedIncomeTax = calculateIncomeTax(taxablePay.value);
  const calculatedLocalTax = Math.round(calculatedIncomeTax * 0.1);
  
  return {
    incomeTax: applyEmployeeDeductions.value.incomeTax ? calculatedIncomeTax : 0,
    localTax: applyEmployeeDeductions.value.localTax ? calculatedLocalTax : 0,
    total: (applyEmployeeDeductions.value.incomeTax ? calculatedIncomeTax : 0) + (applyEmployeeDeductions.value.localTax ? calculatedLocalTax : 0)
  };
});

// 근로자 공제 합계
const totalEmployeeDeductions = computed(() => {
  return employeeDeductions.value.nationalPension +
         employeeDeductions.value.healthInsurance +
         employeeDeductions.value.longTermCare +
         employeeDeductions.value.employmentInsurance +
         tax.value.incomeTax +
         tax.value.localTax +
         employeeDeductions.value.supportDeduction;
});

// 기관 공제 합계
const totalCenterDeductions = computed(() => {
  return centerDeductions.value.nationalPension +
         centerDeductions.value.healthInsurance +
         centerDeductions.value.longTermCare +
         centerDeductions.value.employmentInsurance +
         centerDeductions.value.unemployment +
         centerDeductions.value.industrialAccident +
         centerDeductions.value.retirement;
});

// 실수령액 계산
const netPay = computed(() => {
  // 월 급여(기본급 + 주휴수당 + 연차수당) - 근로자 공제금액
  return Math.max(0, basicTotalPay.value - totalEmployeeDeductions.value);
});

// 금액 포맷팅 함수
const formatMoney = (amount: number) => {
  if (!amount) return "0";
  return new Intl.NumberFormat("ko-KR").format(amount);
};

// 퇴직금 적용 가능 여부에 따라 체크박스 자동 설정/해제
watch(canApplyRetirement, (newValue) => {
  if (!newValue && applyCenterDeductions.value.retirement) {
    // 60시간 미만이면 체크박스 해제
    applyCenterDeductions.value.retirement = false;
  } else if (newValue && !applyCenterDeductions.value.retirement) {
    // 60시간 이상이 되면 체크박스 자동 활성화
    applyCenterDeductions.value.retirement = true;
  }
});

// 토글 함수
const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

// 크기 조절 시작
const startResize = (e: MouseEvent) => {
  isResizing.value = true;
  resizeStartY.value = e.clientY;
  resizeStartHeight.value = panelHeight.value;
  
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
  
  // 커서 변경 및 선택 방지
  document.body.style.cursor = 'ns-resize';
  document.body.style.userSelect = 'none';
  e.preventDefault();
};

// 크기 조절 중
const handleMouseMove = (e: MouseEvent) => {
  if (!isResizing.value) return;
  
  // 위로 드래그하면 패널이 커지도록 deltaY 계산 (부호 반대)
  const deltaY = resizeStartY.value - e.clientY;
  const newHeight = resizeStartHeight.value + deltaY;
  
  // 최소/최대 높이 제한 (90vh)
  const minHeight = 400;
  const maxHeight = window.innerHeight * 0.9;
  
  panelHeight.value = Math.max(minHeight, Math.min(maxHeight, newHeight));
};

// 크기 조절 종료
const handleMouseUp = () => {
  if (isResizing.value) {
    isResizing.value = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }
};

// 화면 크기 변경 시 패널 높이 조정
const handleWindowResize = () => {
  if (!isExpanded.value) return;
  
  const maxHeight = window.innerHeight * 0.9;
  const minHeight = 400;
  
  // 현재 패널 높이가 최대 높이를 초과하면 조정
  if (panelHeight.value > maxHeight) {
    panelHeight.value = maxHeight;
  }
  // 최소 높이보다 작으면 조정
  if (panelHeight.value < minHeight) {
    panelHeight.value = minHeight;
  }
};

// 컴포넌트 마운트 시 세금 데이터 로드
onMounted(async () => {
  await getTax();
  await loadHolidays();
  await loadSuga();
  // 초기 근무일수 기본값 20일 설정
  workingDaysInput.value = '20';
  
  // 화면 크기 변경 이벤트 리스너 추가
  window.addEventListener('resize', handleWindowResize);
});

// 컴포넌트 언마운트 시 이벤트 리스너 정리
onUnmounted(() => {
  handleMouseUp();
  window.removeEventListener('resize', handleWindowResize);
  stopContinuousIncrement(); // 연속 실행 타이머 정리
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isExpanded.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "floating-btn",
          color: "primary",
          variant: "elevated",
          onClick: toggleExpanded,
          size: "large",
          icon: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createTextVNode("mdi-calculator", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isExpanded.value)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "calc-panel",
          elevation: "8",
          style: _normalizeStyle({ height: panelHeight.value + 'px' })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["resize-handle", { 'resizing': isResizing.value }]),
              onMousedown: startResize,
              title: "드래그하여 크기 조절"
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                  _createTextVNode("mdi-drag-vertical", -1)
                ]))]),
                _: 1
              })
            ], 34),
            _createVNode(_component_v_card_title, { class: "calc-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, { class: "header-icon" }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode("mdi-calculator", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "header-title" }, "급여계산기", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event)),
                    class: "year-select",
                    onChange: onYearChange
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_3))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, selectedYear.value]
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  size: "small",
                  variant: "text",
                  onClick: toggleExpanded,
                  class: "close-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "calc-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[48] || (_cache[48] = _createElementVNode("span", null, "시간당 임금", -1)),
                        (totalHourlyWage.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(totalHourlyWage.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "result-label" }, "시급", -1)),
                          _createElementVNode("span", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hourlyWage).value = $event)),
                                onFocus: onHourlyWageFocus,
                                onBlur: onHourlyWageBlur,
                                onInput: onHourlyWageInput,
                                onKeydown: _withKeys(onHourlyWageEnter, ["enter"]),
                                class: "wage-input",
                                maxlength: "9"
                              }, null, 544), [
                                [_vModelText, hourlyWage.value]
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "wage-control-btn up",
                                  onMousedown: _cache[2] || (_cache[2] = ($event: any) => (startContinuousIncrement('hourlyWage'))),
                                  onMouseup: stopContinuousIncrement,
                                  onMouseleave: stopContinuousIncrement,
                                  title: "1원 증가"
                                }, [
                                  _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                      _createTextVNode("mdi-chevron-up", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 32),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "wage-control-btn down",
                                  onMousedown: _cache[3] || (_cache[3] = ($event: any) => (startContinuousDecrement('hourlyWage'))),
                                  onMouseup: stopContinuousIncrement,
                                  onMouseleave: stopContinuousIncrement,
                                  title: "1원 감소"
                                }, [
                                  _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                      _createTextVNode("mdi-chevron-down", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 32)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[52] || (_cache[52] = _createElementVNode("span", { class: "result-label" }, "주휴수당", -1)),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(weeklyHolidayAllowance.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", { class: "result-label" }, [
                            _cache[53] || (_cache[53] = _createTextVNode(" 연차수당 ", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "calculate-btn",
                              onClick: calculateAnnualLeaveByHourlyWage,
                              title: "시급 기준으로 연차수당 계산"
                            }, " 시급기준계산하기 ")
                          ]),
                          _createElementVNode("span", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((annualLeaveAllowance).value = $event)),
                                onFocus: onAnnualLeaveAllowanceFocus,
                                onBlur: onAnnualLeaveAllowanceBlur,
                                onInput: onAnnualLeaveAllowanceInput,
                                onKeydown: _withKeys(onAnnualLeaveAllowanceEnter, ["enter"]),
                                class: "wage-input",
                                maxlength: "9"
                              }, null, 544), [
                                [_vModelText, annualLeaveAllowance.value]
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "wage-control-btn up",
                                  onMousedown: _cache[5] || (_cache[5] = ($event: any) => (startContinuousIncrement('annualLeave'))),
                                  onMouseup: stopContinuousIncrement,
                                  onMouseleave: stopContinuousIncrement,
                                  title: "1원 증가"
                                }, [
                                  _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                      _createTextVNode("mdi-chevron-up", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 32),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "wage-control-btn down",
                                  onMousedown: _cache[6] || (_cache[6] = ($event: any) => (startContinuousDecrement('annualLeave'))),
                                  onMouseup: stopContinuousIncrement,
                                  onMouseleave: stopContinuousIncrement,
                                  title: "1원 감소"
                                }, [
                                  _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                      _createTextVNode("mdi-chevron-down", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 32)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "result-label" }, "근무일수", -1)),
                            _createElementVNode("span", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((workingDaysInput).value = $event)),
                                  onInput: onWorkingDaysInput,
                                  onKeydown: _withKeys(onWorkingDaysEnter, ["enter"]),
                                  class: "wage-input",
                                  placeholder: "근무일수 입력",
                                  maxlength: "3"
                                }, null, 544), [
                                  [_vModelText, workingDaysInput.value]
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "wage-control-btn up",
                                    onMousedown: _cache[8] || (_cache[8] = ($event: any) => (startContinuousIncrement('workingDays'))),
                                    onMouseup: stopContinuousIncrement,
                                    onMouseleave: stopContinuousIncrement,
                                    title: "1일 증가"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                        _createTextVNode("mdi-chevron-up", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 32),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "wage-control-btn down",
                                    onMousedown: _cache[9] || (_cache[9] = ($event: any) => (startContinuousDecrement('workingDays'))),
                                    onMouseup: stopContinuousIncrement,
                                    onMouseleave: stopContinuousIncrement,
                                    title: "1일 감소"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                        _createTextVNode("mdi-chevron-down", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 32)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[59] || (_cache[59] = _createElementVNode("span", null, "월 급여", -1)),
                        (basicTotalPay.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatMoney(basicTotalPay.value)) + "원", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _cache[60] || (_cache[60] = _createElementVNode("span", { class: "result-label" }, "기본급", -1)),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(formatMoney(basicPay.value)) + "원", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _cache[61] || (_cache[61] = _createElementVNode("span", { class: "result-label" }, "주휴수당", -1)),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(formatMoney(weeklyHolidayPay.value)) + "원", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _cache[62] || (_cache[62] = _createElementVNode("span", { class: "result-label" }, "연차수당", -1)),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(formatMoney(annualLeavePay.value)) + "원", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _cache[63] || (_cache[63] = _createElementVNode("span", null, "월 수가", -1)),
                        (monthlyTotalWage.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(monthlyTotalWage.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[65] || (_cache[65] = _createElementVNode("span", { class: "result-label" }, "시간 선택 (수가)", -1)),
                          _createElementVNode("span", _hoisted_44, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedSugaTime).value = $event)),
                              onChange: onSugaTimeChange,
                              class: "suga-time-select"
                            }, [
                              _cache[64] || (_cache[64] = _createElementVNode("option", { value: "" }, "시간을 선택하세요", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sugaList.value, (suga) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: suga.suga_idx,
                                  value: suga.suga_rank
                                }, _toDisplayString(suga.suga_rank) + " - " + _toDisplayString(formatMoney(Number(suga.suga_money))) + "원 ", 9, _hoisted_45))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, selectedSugaTime.value]
                            ])
                          ])
                        ])
                      ]),
                      (selectedSugaTime.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _cache[66] || (_cache[66] = _createElementVNode("span", { class: "result-label" }, "일당", -1)),
                              _createElementVNode("span", _hoisted_48, _toDisplayString(selectedSuga.value ? formatMoney(Number(selectedSuga.value.suga_money)) + '원' : ''), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (hourlyWage.value && parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createVNode(_component_v_card, {
                          class: "final-result-card",
                          elevation: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "card-title" }, {
                              default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                _createElementVNode("span", null, "최종 결과", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "card-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_50, [
                                  _cache[68] || (_cache[68] = _createElementVNode("span", { class: "final-label" }, "월 급여", -1)),
                                  _createElementVNode("span", _hoisted_51, _toDisplayString(formatMoney(basicTotalPay.value)) + "원", 1)
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", {
                                    class: "final-result-item-header",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (showDetail.value.employeeDeductions = !showDetail.value.employeeDeductions))
                                  }, [
                                    _cache[69] || (_cache[69] = _createElementVNode("span", { class: "final-label" }, "근로자 공제", -1)),
                                    _createElementVNode("span", _hoisted_53, [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(showDetail.value.employeeDeductions ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" -" + _toDisplayString(formatMoney(totalEmployeeDeductions.value)) + "원 ", 1)
                                    ])
                                  ]),
                                  (showDetail.value.employeeDeductions)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("span", _hoisted_56, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((applyEmployeeDeductions.value.nationalPension) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.nationalPension]
                                            ]),
                                            _cache[70] || (_cache[70] = _createTextVNode(" 국민연금 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_57, _toDisplayString(formatMoney(employeeDeductions.value.nationalPension)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("span", _hoisted_59, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((applyEmployeeDeductions.value.healthInsurance) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.healthInsurance]
                                            ]),
                                            _cache[71] || (_cache[71] = _createTextVNode(" 건강보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_60, _toDisplayString(formatMoney(employeeDeductions.value.healthInsurance)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("span", _hoisted_62, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((applyEmployeeDeductions.value.longTermCare) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.longTermCare]
                                            ]),
                                            _cache[72] || (_cache[72] = _createTextVNode(" 장기요양보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_63, _toDisplayString(formatMoney(employeeDeductions.value.longTermCare)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("span", _hoisted_65, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((applyEmployeeDeductions.value.employmentInsurance) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.employmentInsurance]
                                            ]),
                                            _cache[73] || (_cache[73] = _createTextVNode(" 고용보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_66, _toDisplayString(formatMoney(employeeDeductions.value.employmentInsurance)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                          _createElementVNode("span", _hoisted_68, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((applyEmployeeDeductions.value.incomeTax) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.incomeTax]
                                            ]),
                                            _cache[74] || (_cache[74] = _createTextVNode(" 소득세 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_69, _toDisplayString(formatMoney(tax.value.incomeTax)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_70, [
                                          _createElementVNode("span", _hoisted_71, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((applyEmployeeDeductions.value.localTax) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.localTax]
                                            ]),
                                            _cache[75] || (_cache[75] = _createTextVNode(" 지방세 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_72, _toDisplayString(formatMoney(tax.value.localTax)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("span", _hoisted_74, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((applyEmployeeDeductions.value.supportDeduction) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyEmployeeDeductions.value.supportDeduction]
                                            ]),
                                            _cache[76] || (_cache[76] = _createTextVNode(" 지원공제 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_75, _toDisplayString(formatMoney(employeeDeductions.value.supportDeduction)) + "원", 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _cache[77] || (_cache[77] = _createElementVNode("span", { class: "final-label" }, "실수령액", -1)),
                                  _createElementVNode("span", _hoisted_77, _toDisplayString(formatMoney(netPay.value)) + "원", 1)
                                ]),
                                _cache[89] || (_cache[89] = _createElementVNode("div", { class: "divider" }, null, -1)),
                                _createElementVNode("div", _hoisted_78, [
                                  _cache[78] || (_cache[78] = _createElementVNode("span", { class: "final-label" }, "월 수가", -1)),
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(sugaTotalAmount.value), 1)
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                  _cache[79] || (_cache[79] = _createElementVNode("span", { class: "final-label" }, "월 급여", -1)),
                                  _createElementVNode("span", _hoisted_81, "-" + _toDisplayString(formatMoney(basicTotalPay.value)) + "원", 1)
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("div", {
                                    class: "final-result-item-header",
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (showDetail.value.centerDeductions = !showDetail.value.centerDeductions))
                                  }, [
                                    _cache[80] || (_cache[80] = _createElementVNode("span", { class: "final-label" }, "기관 공제", -1)),
                                    _createElementVNode("span", _hoisted_83, [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "ml-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(showDetail.value.centerDeductions ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" -" + _toDisplayString(formatMoney(totalCenterDeductions.value)) + "원 ", 1)
                                    ])
                                  ]),
                                  (showDetail.value.centerDeductions)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("span", _hoisted_86, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((applyCenterDeductions.value.nationalPension) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.nationalPension]
                                            ]),
                                            _cache[81] || (_cache[81] = _createTextVNode(" 국민연금 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_87, _toDisplayString(formatMoney(centerDeductions.value.nationalPension)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_88, [
                                          _createElementVNode("span", _hoisted_89, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((applyCenterDeductions.value.healthInsurance) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.healthInsurance]
                                            ]),
                                            _cache[82] || (_cache[82] = _createTextVNode(" 건강보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_90, _toDisplayString(formatMoney(centerDeductions.value.healthInsurance)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_91, [
                                          _createElementVNode("span", _hoisted_92, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((applyCenterDeductions.value.longTermCare) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.longTermCare]
                                            ]),
                                            _cache[83] || (_cache[83] = _createTextVNode(" 장기요양보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_93, _toDisplayString(formatMoney(centerDeductions.value.longTermCare)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_94, [
                                          _createElementVNode("span", _hoisted_95, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((applyCenterDeductions.value.employmentInsurance) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.employmentInsurance]
                                            ]),
                                            _cache[84] || (_cache[84] = _createTextVNode(" 고용보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_96, _toDisplayString(formatMoney(centerDeductions.value.employmentInsurance)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_97, [
                                          _createElementVNode("span", _hoisted_98, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((applyCenterDeductions.value.unemployment) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.unemployment]
                                            ]),
                                            _cache[85] || (_cache[85] = _createTextVNode(" 실업급여 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_99, _toDisplayString(formatMoney(centerDeductions.value.unemployment)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_100, [
                                          _createElementVNode("span", _hoisted_101, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((applyCenterDeductions.value.industrialAccident) = $event)),
                                              class: "deduction-checkbox"
                                            }, null, 512), [
                                              [_vModelCheckbox, applyCenterDeductions.value.industrialAccident]
                                            ]),
                                            _cache[86] || (_cache[86] = _createTextVNode(" 산재보험 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_102, _toDisplayString(formatMoney(centerDeductions.value.industrialAccident)) + "원", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_103, [
                                          _createElementVNode("span", _hoisted_104, [
                                            _createVNode(_component_v_tooltip, {
                                              disabled: !retirementTooltipMessage.value || canApplyRetirement.value,
                                              location: "top"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _withDirectives(_createElementVNode("input", _mergeProps({
                                                  type: "checkbox",
                                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((applyCenterDeductions.value.retirement) = $event)),
                                                  disabled: !canApplyRetirement.value,
                                                  class: "deduction-checkbox"
                                                }, props), null, 16, _hoisted_105), [
                                                  [_vModelCheckbox, applyCenterDeductions.value.retirement]
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_106, _toDisplayString(retirementTooltipMessage.value), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"]),
                                            _cache[87] || (_cache[87] = _createTextVNode(" 퇴직금 ", -1))
                                          ]),
                                          _createElementVNode("span", _hoisted_107, _toDisplayString(formatMoney(centerDeductions.value.retirement)) + "원", 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_108, [
                                  _cache[88] || (_cache[88] = _createElementVNode("span", { class: "final-label" }, "기관 수익", -1)),
                                  _createElementVNode("span", _hoisted_109, _toDisplayString(formatMoney(netProfit.value)) + "원", 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (false && hourlyWage.value && parseFloat(String(hourlyWage.value).replace(/[^\d]/g, '')) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                        _createVNode(_component_v_card, {
                          class: "calculation-card",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "card-title" }, {
                              default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                                _createElementVNode("span", null, "월 평균 급여 계산", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "card-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_111, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _cache[91] || (_cache[91] = _createElementVNode("span", { class: "result-label" }, "기본급", -1)),
                                    _createElementVNode("span", _hoisted_113, _toDisplayString(formatMoney(basicPay.value)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _cache[92] || (_cache[92] = _createElementVNode("span", { class: "result-label" }, "주휴수당", -1)),
                                    _createElementVNode("span", _hoisted_115, _toDisplayString(formatMoney(weeklyHolidayPay.value)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_116, [
                                    _cache[93] || (_cache[93] = _createElementVNode("span", { class: "result-label" }, "연차수당", -1)),
                                    _createElementVNode("span", _hoisted_117, _toDisplayString(formatMoney(annualLeavePay.value)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_118, [
                                    _cache[94] || (_cache[94] = _createElementVNode("span", { class: "result-label" }, "기본급여 합계", -1)),
                                    _createElementVNode("span", _hoisted_119, _toDisplayString(formatMoney(basicTotalPay.value)) + "원 ", 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card, {
                          class: "calculation-card",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "card-title" }, {
                              default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                                _createElementVNode("span", null, "근로자 공제", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "card-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _createElementVNode("span", _hoisted_122, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((applyEmployeeDeductions.value.nationalPension) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.nationalPension]
                                      ]),
                                      _cache[96] || (_cache[96] = _createTextVNode(" 국민연금 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_123, _toDisplayString(formatMoney(employeeDeductions.value.nationalPension)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("span", _hoisted_125, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((applyEmployeeDeductions.value.healthInsurance) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.healthInsurance]
                                      ]),
                                      _cache[97] || (_cache[97] = _createTextVNode(" 건강보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_126, _toDisplayString(formatMoney(employeeDeductions.value.healthInsurance)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_127, [
                                    _createElementVNode("span", _hoisted_128, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((applyEmployeeDeductions.value.longTermCare) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.longTermCare]
                                      ]),
                                      _cache[98] || (_cache[98] = _createTextVNode(" 장기요양보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_129, _toDisplayString(formatMoney(employeeDeductions.value.longTermCare)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_130, [
                                    _createElementVNode("span", _hoisted_131, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((applyEmployeeDeductions.value.employmentInsurance) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.employmentInsurance]
                                      ]),
                                      _cache[99] || (_cache[99] = _createTextVNode(" 고용보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_132, _toDisplayString(formatMoney(employeeDeductions.value.employmentInsurance)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("span", _hoisted_134, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((applyEmployeeDeductions.value.incomeTax) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.incomeTax]
                                      ]),
                                      _cache[100] || (_cache[100] = _createTextVNode(" 소득세 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_135, _toDisplayString(formatMoney(tax.value.incomeTax)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_136, [
                                    _createElementVNode("span", _hoisted_137, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((applyEmployeeDeductions.value.localTax) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.localTax]
                                      ]),
                                      _cache[101] || (_cache[101] = _createTextVNode(" 지방세 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_138, _toDisplayString(formatMoney(tax.value.localTax)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_139, [
                                    _createElementVNode("span", _hoisted_140, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((applyEmployeeDeductions.value.supportDeduction) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyEmployeeDeductions.value.supportDeduction]
                                      ]),
                                      _cache[102] || (_cache[102] = _createTextVNode(" 지원공제 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_141, _toDisplayString(formatMoney(employeeDeductions.value.supportDeduction)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_142, [
                                    _cache[103] || (_cache[103] = _createElementVNode("span", { class: "result-label" }, "근로자 공제 합계", -1)),
                                    _createElementVNode("span", _hoisted_143, _toDisplayString(formatMoney(totalEmployeeDeductions.value)) + "원 ", 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card, {
                          class: "calculation-card",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "card-title" }, {
                              default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                                _createElementVNode("span", null, "기관 공제", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "card-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_144, [
                                  _createElementVNode("div", _hoisted_145, [
                                    _createElementVNode("span", _hoisted_146, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((applyCenterDeductions.value.nationalPension) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.nationalPension]
                                      ]),
                                      _cache[105] || (_cache[105] = _createTextVNode(" 국민연금 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_147, _toDisplayString(formatMoney(centerDeductions.value.nationalPension)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("span", _hoisted_149, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((applyCenterDeductions.value.healthInsurance) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.healthInsurance]
                                      ]),
                                      _cache[106] || (_cache[106] = _createTextVNode(" 건강보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_150, _toDisplayString(formatMoney(centerDeductions.value.healthInsurance)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("span", _hoisted_152, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((applyCenterDeductions.value.longTermCare) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.longTermCare]
                                      ]),
                                      _cache[107] || (_cache[107] = _createTextVNode(" 장기요양보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_153, _toDisplayString(formatMoney(centerDeductions.value.longTermCare)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_154, [
                                    _createElementVNode("span", _hoisted_155, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((applyCenterDeductions.value.employmentInsurance) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.employmentInsurance]
                                      ]),
                                      _cache[108] || (_cache[108] = _createTextVNode(" 고용보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_156, _toDisplayString(formatMoney(centerDeductions.value.employmentInsurance)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_157, [
                                    _createElementVNode("span", _hoisted_158, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((applyCenterDeductions.value.unemployment) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.unemployment]
                                      ]),
                                      _cache[109] || (_cache[109] = _createTextVNode(" 실업급여 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_159, _toDisplayString(formatMoney(centerDeductions.value.unemployment)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_160, [
                                    _createElementVNode("span", _hoisted_161, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((applyCenterDeductions.value.industrialAccident) = $event)),
                                        class: "deduction-checkbox"
                                      }, null, 512), [
                                        [_vModelCheckbox, applyCenterDeductions.value.industrialAccident]
                                      ]),
                                      _cache[110] || (_cache[110] = _createTextVNode(" 산재보험 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_162, _toDisplayString(formatMoney(centerDeductions.value.industrialAccident)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_163, [
                                    _createElementVNode("span", _hoisted_164, [
                                      _createVNode(_component_v_tooltip, {
                                        disabled: !retirementTooltipMessage.value || canApplyRetirement.value,
                                        location: "top"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _withDirectives(_createElementVNode("input", _mergeProps({
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((applyCenterDeductions.value.retirement) = $event)),
                                            disabled: !canApplyRetirement.value,
                                            class: "deduction-checkbox"
                                          }, props), null, 16, _hoisted_165), [
                                            [_vModelCheckbox, applyCenterDeductions.value.retirement]
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_166, _toDisplayString(retirementTooltipMessage.value), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _cache[111] || (_cache[111] = _createTextVNode(" 퇴직금 ", -1))
                                    ]),
                                    _createElementVNode("span", _hoisted_167, _toDisplayString(formatMoney(centerDeductions.value.retirement)) + "원 ", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_168, [
                                    _cache[112] || (_cache[112] = _createElementVNode("span", { class: "result-label" }, "기관 공제 합계", -1)),
                                    _createElementVNode("span", _hoisted_169, _toDisplayString(formatMoney(totalCenterDeductions.value)) + "원 ", 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000,
      location: "bottom"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _cache[41] || (_cache[41] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[113] || (_cache[113] = [
            _createTextVNode("닫기", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})